export const POSITION = {
    TRACKING: {
        SEARCH_TEXT_FIELD: {
            action: 'TYPING_TRACKING',
            event_category: 'tracking'
        }
    }
}